// Em "npm start" (NODE_ENV=development) o portal usa a API local.
// REACT_APP_API sobrescreve em qualquer ambiente.
const isDev = process.env.NODE_ENV === 'development';

const config = {
    apiMaster: process.env.REACT_APP_API_MASTER || 'https://master.checkstore.app',
    api: process.env.REACT_APP_API || (isDev ? 'http://localhost:8080' : 'https://apiatendimento.checkstore.app')
};

export default config;
